import Constants from "../constants/Constants";

export default class ElementsHandler {

    constructor(gameCtx) {
        this.gameCtx = gameCtx;
        this.elements = [];
    }


    addElement = (key, elem) => { //here stop the timer, only if a popup
        let i = this.elements.findIndex(e => { return (e && e.key) ? e.key === key : false });

        if (i === -1) {
            this.elements.push({ key, elem });
        }
        else {
            this.elements[i] = { key, elem };
        }

        if(key === Constants.ELEMENT_CARD_POPUP){
            this.gameCtx.gameTimerRef.current.pauseTimer()
        }

        this.gameCtx.setState({ elements: this.elements });
    }

    removeElement = (key) => { //here continue the timer, only if a popup
        if (this.elements.length < 1) {
            console.log("NOTE: Could not remove element because this.elements is empty");
        }

        let i = this.elements.findIndex(e => {
            return e.key === key;
        });

        if(key === Constants.ELEMENT_CARD_POPUP){
            this.gameCtx.gameTimerRef.current.resumeTimer()
        }

        if (i !== -1) {
            this.elements.splice(i, 1);
            this.gameCtx.setState({ elements: this.elements });

        } else {
            console.log("NOTE: Can't remove element because it doesn't exist");
        }
    }

    getElements = () => {
        return this.elements;
    }
}